import styled from "styled-components"
import theme from "../../../theme"

export const Contact = styled.section`
  display: inline-flex;
  flex-direction: column;
  overflow: hidden;
  padding: 2rem;
  margin-bottom: 32px;
  
  @media (min-width: 1024px) {
    max-width: 1240px;
    min-width: 920px;
  }
`

export const ContactHeadline = styled.h1`
  font-size: 2rem;
  background-image:linear-gradient(90deg,${theme.brand.default},${theme.brand.alt},${theme.brand.default});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -.015em;
  margin-bottom: 8px;
`

export const ContactSub = styled.h2`
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -.015em;
  color: ${theme.text.alt};
  margin: 0 0 8px 0;
`


export const ContactContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top: 32px;
`


export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 50%;
  line-height: 1.47059;
  font-size: 1.15rem;
  color: ${theme.text.default};
  font-weight: 400;
  letter-spacing: -.022em;
`

export const ContactInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 50%;
  line-height: 1.47059;
  font-size: 1.15rem;
  color: ${theme.text.default};
  font-weight: 400;
  letter-spacing: -.022em;
`
